import React from "react";
import { Form, Row, Col, InputGroup } from "react-bootstrap";
import DateRange from "@material-ui/icons/DateRange";
import moment from "moment";
import "bootstrap-daterangepicker/daterangepicker.css";
import PropTypes from "prop-types";
import validation from "react-validation-mixin";
import strategy from "joi-validation-strategy";
import Joi from "joi";
import APIUtil from "../../../config/APIUtil";
import UrlConstants from "../../../config/UrlConstants";
import InputMask from "react-input-mask";
import DatePicker from "react-date-picker";
import { getToday } from "../../Common/Common";
import * as message from "./../../../config/CommonMessages";
import * as code from "./../../../config/Constants";

var minDate = getToday();

class InvitePersonalInfo extends React.Component {
  constructor(props) {
    super(props);

    // this.setStartDate = this.setStartDate.bind(this);
    // this.setAgentDate = this.setAgentDate.bind(this);

    this.state = {
      // // startDate: props.getUserData().licenseExpirationDate,
      // agentDate: props.getUserData().agentLicenseExpirationDate,
      firstname: props.getUserData().firstname,
      lastname: props.getUserData().lastname,
      email: props.getUserData().email,
      recoveryEmail: props.getUserData().recoveryEmail,
      mobileNumber: props.getUserData().mobileNumber,
      otherNumber: props.getUserData().otherNumber,
      // brokerLicenseNo: props.getUserData().brokerLicenseNo,
      // agentLicenseNo: props.getUserData().agentLicenseNo,
      // licenseExpirationDate: props.getUserData().licenseExpirationDate,
      // agentLicenseExpirationDate: props.getUserData()
      //   .agentLicenseExpirationDate,
      knowAboutUs: props.getUserData().knowAboutUs,
      isEmailExist: false,
      isEmailDeleted: false,
      socialMediaHandles: {
        facebook: props.getUserData().socialMediaHandles.facebook,
        // twitter: props.getUserData().socialMediaHandles.twitter,
        instagram: props.getUserData().socialMediaHandles.instagram,
        // zillow: props.getUserData().socialMediaHandles.zillow,
        // realtor: props.getUserData().socialMediaHandles.realtor,
      },
      mobileDuplicate: false,
      validFirstName: false,
      validLastName: false,
    };

    this.validatorTypes = function() {
      var base = Joi.object().keys({
        email: Joi.string()
          .email()
          .required()
          .label("Email ID"),
        firstname: Joi.string()
          .required()
          .label("First Name"),
        lastname: Joi.string()
          .required()
          .label("Last Name"),
        recoveryEmail: Joi.string()
          .email()
          .required()
          .label("Confirm Email ID"),
        recoveryEmail: Joi.ref("email"),
        mobileNumber: Joi.string()
          .regex(new RegExp("^[0-9]{3}-[0-9]{3}-[0-9]{4}?$"))
          .required()
          .label("Mobile No"),
        otherNumber: Joi.string()
          .allow("")
          .regex(new RegExp("^[0-9]{3}-[0-9]{3}-[0-9]{4}?$"))
          .label("Phone No. (Office)"),
        // brokerLicenseNo: Joi.string()
        //   .required()
        //   .label("Broker License No"),
        socialMediaHandles: Joi.object().keys({
          facebook: Joi.string()
            .allow("")
            .regex(
              new RegExp(
                /(http(s)?):\/\/(www\.)|[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/
              )
            )
            .label("Facebook URL"),
          instagram: Joi.string()
            .allow("")
            .regex(
              new RegExp(
                /(http(s)?):\/\/(www\.)|[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/
              )
            )
            .label("instagram URL"),
          zillow: Joi.string()
            .allow("")
            .regex(
              new RegExp(
                /(http(s)?):\/\/(www\.)|[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/
              )
            )
            .label("Zillow URL"),
          realtor: Joi.string()
            .allow("")
            .regex(
              new RegExp(
                /(http(s)?):\/\/(www\.)|[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/
              )
            )
            .label("Realtor.com URL"),
        }),
      });

      return base;
    };

    this.getValidatorData = this.getValidatorData.bind(this);
    this.renderHelpText = this.renderHelpText.bind(this);
    this.isValidated = this.isValidated.bind(this);
  }

  /**
   * @desc get validator data
   * this object is used to perform validation based on set joi validation schema
   */
  getValidatorData() {
    return {
      ...this.state,
      firstname: this.props.getUserData().firstname,
      lastname: this.props.getUserData().lastname,
      email: this.props.getUserData().email,
      recoveryEmail: this.props.getUserData().recoveryEmail,
      mobileNumber: this.props.getUserData().mobileNumber,
      otherNumber: this.props.getUserData().otherNumber,
      // brokerLicenseNo: this.props.getUserData().brokerLicenseNo,
      // agentLicenseNo: this.props.getUserData().agentLicenseNo,
      // licenseExpirationDate: this.props.getUserData().licenseExpirationDate,
      knowAboutUs: this.props.getUserData().knowAboutUs,
      socialMediaHandles: {
        facebook: this.props.getUserData().socialMediaHandles.facebook,
        instagram: this.props.getUserData().socialMediaHandles.instagram,
        // instagram: this.props.getUserData().socialMediaHandles.instagram,
        // zillow: this.props.getUserData().socialMediaHandles.zillow,
        // realtor: this.props.getUserData().socialMediaHandles.realtor,
      },
    };
  }

  /**
   * @desc check form is validate or not
   */
  isValidated() {
    return new Promise((resolve, reject) => {
      this.props.validate((error) => {
        if (
          error ||
          this.state.isEmailExist ||
          this.state.isEmailDeleted ||
          this.state.mobileDuplicate ||
          this.state.validFirstName ||
          this.state.validLastName
        ) {
          reject();
          return;
        }
        resolve();
      });
    });
  }

  renderHelpText(message, id) {
    return (
      <div className="val-err-tooltip" key={id}>
        <span>{message}</span>
      </div>
    );
  }

  checkNameValidation(value) {
    // console.log("checkNameValidation value", value);
    let nameRegEx = /^[A-Za-z '-]{0,50}$/;
    if (nameRegEx.test(value)) {
      // console.log("matched");
      return true;
    } else {
      // console.log("not matched");
      return false;
    }
  }

  /**
   * @desc on change event of input tags and set data to state and also updating data in parent component
   */
  onChange(event) {
    let val = event.target.value;

    if (event.target.name === "firstname") {
      !this.checkNameValidation(val)
        ? this.setState({ validFirstName: true })
        : this.setState({ validFirstName: false });
    }
    if (event.target.name === "lastname") {
      !this.checkNameValidation(val)
        ? this.setState({ validLastName: true })
        : this.setState({ validLastName: false });
    }

    if (event.target.name === "email") {
      this.checkEmailExist(val);
    }

    if (event.target.name === "mobileNumber") {
      var mob = val.replace(/-/g, "");
      if (mob.length === 10) {
        this.CheckMobileunique(mob);
      } else {
        this.setState({ mobileDuplicate: false });
      }
    }

    if (event.target.name === "socialMediaHandles.facebook") {
      let socials = this.state.socialMediaHandles;
      socials.facebook = val;
      this.setState({ socialMediaHandles: socials });
      this.props.updateUserData("socialMediaHandles", socials);
    } else if (event.target.name === "socialMediaHandles.instagram") {
      let socials = this.state.socialMediaHandles;
      socials.instagram = val;
      this.setState({ socialMediaHandles: socials });
      this.props.updateUserData("socialMediaHandles", socials);
    } else if (event.target.name === "socialMediaHandles.zillow") {
      let socials = this.state.socialMediaHandles;
      socials.zillow = val;
      this.setState({ socialMediaHandles: socials });
      this.props.updateUserData("socialMediaHandles", socials);
    } else if (event.target.name === "socialMediaHandles.realtor") {
      let socials = this.state.socialMediaHandles;
      socials.realtor = val;
      this.setState({ socialMediaHandles: socials });
      this.props.updateUserData("socialMediaHandles", socials);
    } else {
      this.setState({ [event.target.name]: val });
      this.props.updateUserData(event.target.name, val);
    }
  }

  setStartDate(date) {
    this.setState({
      startDate: moment(date),
    });
    let selDate = moment(date)
      .local()
      .format("YYYY-MM-DD");
    this.props.updateUserData("licenseExpirationDate", selDate);
  }

  setAgentDate(date) {
    this.setState({
      agentDate: moment(date),
    });
    let selDate = moment(date)
      .local()
      .format("YYYY-MM-DD");
    this.props.updateUserData("agentLicenseExpirationDate", selDate);
  }
  /**
   * @desc get error message for given field from errlist from validator
   */
  getErrorMsg(field, errsList) {
    var err = "";

    if (
      field === "firstname" ||
      field === "lastname"
      // field === "brokerLicenseNo"
    ) {
      if (
        errsList[field] !== undefined &&
        errsList[field] !== null &&
        errsList[field] !== ""
      ) {
        if (field === "firstname") {
          err = message.ENTER_FIRST_NAME;
        }
        if (field === "lastname") {
          err = message.ENTER_LAST_NAME;
        }
        // if (field === "brokerLicenseNo") {
        //   err = message.ENTER_BROKER_LICENSE;
        // }
      }
    }
    if (field === "email") {
      if (
        errsList[field] !== undefined &&
        errsList[field] !== null &&
        errsList[field] !== ""
      ) {
        if (errsList[field].length === 2) {
          err = message.ENTER_EMAIL;
        }
        if (errsList[field].length === 1) {
          err = message.ENTER_VALID_EMAIL;
        }
      }
    }

    if (field === "recoveryEmail") {
      if (
        errsList[field] !== undefined &&
        errsList[field] !== null &&
        errsList[field] !== ""
      ) {
        if (errsList[field].length === 2) {
          err = message.ENTER_CONFIRM_EMAIL;
        }
        if (errsList[field].length === 1) {
          err = message.CONFIRM_EMAIL_SAME_AS_EMAIL;
        }
      }
    }

    if (field === "mobileNumber") {
      if (
        errsList[field] !== undefined &&
        errsList[field] !== null &&
        errsList[field] !== ""
      ) {
        if (errsList[field].length === 2) {
          err = message.ENTER_MOBILE_NUMBER;
        }
        if (errsList[field].length === 1) {
          err = message.MOBILE_10_DIGIT;
        }
      }
    }

    if (field === "otherNumber") {
      if (
        errsList[field] !== undefined &&
        errsList[field] !== null &&
        errsList[field] !== ""
      ) {
        if (errsList[field].length === 2) {
          err = message.ENTER_PHONE;
        }
        if (errsList[field].length === 1) {
          err = message.PHONE_10_DIGIT;
        }
      }
    }

    if (field === "facebook") {
      if (
        errsList["socialMediaHandles,facebook"] !== undefined &&
        errsList["socialMediaHandles,facebook"] !== null &&
        errsList["socialMediaHandles,facebook"] !== ""
      ) {
        err = message.VALID_URL;
      }
    }
    if (field === "instagram") {
      if (
        errsList["socialMediaHandles,instagram"] !== undefined &&
        errsList["socialMediaHandles,instagram"] !== null &&
        errsList["socialMediaHandles,instagram"] !== ""
      ) {
        err = message.VALID_URL;
      }
    }
    if (field === "zillow") {
      if (
        errsList["socialMediaHandles,zillow"] !== undefined &&
        errsList["socialMediaHandles,zillow"] !== null &&
        errsList["socialMediaHandles,zillow"] !== ""
      ) {
        err = message.VALID_URL;
      }
    }
    if (field === "realtor") {
      if (
        errsList["socialMediaHandles,realtor"] !== undefined &&
        errsList["socialMediaHandles,realtor"] !== null &&
        errsList["socialMediaHandles,realtor"] !== ""
      ) {
        err = message.VALID_URL;
      }
    }

    return err;
  }

  /**
   * @desc function to check given email id is registered with system or not
   *
   */
  checkEmailExist(email) {
    APIUtil.getMethod(
      UrlConstants.emailCheckUrl + "?email=" + email,
      false
    ).then((response) => {
      if (response.data && response.data._id !== undefined) {
        if (response.data.isDeleted == true) {
          this.setState({ isEmailDeleted: true });
          this.setState({ isEmailExist: false });
        } else {
          this.setState({ isEmailExist: true });
          this.setState({ isEmailDeleted: false });
        }
      } else {
        this.setState({ isEmailExist: false });
        this.setState({ isEmailDeleted: false });
      }
    });
  }

  /**
   * check mobile is unique
   */
  CheckMobileunique(mobile) {
    APIUtil.getMethod(
      UrlConstants.addContact +
        "/CheckEmailOrMobileUniqueatregistration?mobile=" +
        mobile,
      false
    ).then((response) => {
      if (response && response.data && response.data.error === "Unauthorized") {
        this.setState({ mobileDuplicate: true });
      } else {
        this.setState({ mobileDuplicate: false });
      }
    });
  }

  render() {
    // let startDate = this.state.startDate;
    // let agentDate = this.state.agentDate;

    return (
      <div className="step-content">
        <h4 className="title-blue mb-3">Personal Information</h4>
        <Form className="form-sm">
          <Row>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>
                  First Name<span style={{ color: "#FFFFFF" }}> *</span>
                </Form.Label>
                <Form.Control
                  maxLength="50"
                  defaultValue={this.state.firstname}
                  className="field_ucfirst"
                  onChange={this.onChange.bind(this)}
                  name="firstname"
                  type="text"
                  size="lg"
                  onBlur={this.props.handleValidation("firstname")}
                />

                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("firstname", this.props.errors)
                  )}
                  {this.state.validFirstName
                    ? message.ENTER_VALID_FIRST_NAME
                    : ""}
                </Form.Text>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>
                  Last Name<span style={{ color: "#FFFFFF" }}> *</span>
                </Form.Label>
                <Form.Control
                  maxLength="50"
                  defaultValue={this.state.lastname}
                  className="field_ucfirst"
                  onChange={this.onChange.bind(this)}
                  name="lastname"
                  type="text"
                  size="lg"
                  onBlur={this.props.handleValidation("lastname")}
                />
                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("lastname", this.props.errors)
                  )}
                  {this.state.validLastName
                    ? message.ENTER_VALID_LAST_NAME
                    : ""}
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>
                  Email Address<span style={{ color: "#FFFFFF" }}> *</span>
                </Form.Label>
                <Form.Control
                  maxLength="50"
                  name="email"
                  defaultValue={this.state.email}
                  onChange={this.onChange.bind(this)}
                  type="email"
                  size="lg"
                  onBlur={this.props.handleValidation("email")}
                />
                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("email", this.props.errors)
                  )}
                </Form.Text>
                {this.state.isEmailDeleted && (
                  <Form.Text style={{ color: "#FFFFFF" }}>
                    {this.renderHelpText(
                      "User already exists."
                    )}
                  </Form.Text>
                )}
                {this.state.isEmailExist && (
                  <Form.Text style={{ color: "#FFFFFF" }}>
                    {this.renderHelpText("Email address already exists")}
                  </Form.Text>
                )}
              </Form.Group>
            </Col>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>
                  Confirm Email Address
                  <span style={{ color: "#FFFFFF" }}> *</span>
                </Form.Label>
                <Form.Control
                  maxLength="50"
                  name="recoveryEmail"
                  defaultValue={this.state.recoveryEmail}
                  onChange={this.onChange.bind(this)}
                  type="email"
                  size="lg"
                  onBlur={this.props.handleValidation("recoveryEmail")}
                />
                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("recoveryEmail", this.props.errors)
                  )}
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>
          <Row />
          <Row>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>
                  Mobile No.<span style={{ color: "#FFFFFF" }}> *</span>
                </Form.Label>
                <InputMask
                  mask="999-999-9999"
                  maskChar=""
                  formControlProps={{
                    fullWidth: true,
                  }}
                  className="form-control form-control-lg"
                  value={this.state.mobileNumber}
                  name="mobileNumber"
                  onChange={this.onChange.bind(this)}
                  onBlur={this.props.handleValidation("mobileNumber")}
                >
                  {(inputProps) => <Form.Control {...inputProps} />}
                </InputMask>

                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("mobileNumber", this.props.errors)
                  )}
                  {this.state.mobileDuplicate
                    ? message.MOBILE_NUMBER_EXISTS
                    : ""}
                </Form.Text>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Phone No. (Office)</Form.Label>
                <InputMask
                  mask="999-999-9999"
                  maskChar=""
                  formControlProps={{
                    fullWidth: true,
                  }}
                  className="form-control form-control-lg"
                  value={this.state.otherNumber}
                  name="otherNumber"
                  onChange={this.onChange.bind(this)}
                >
                  {(inputProps) => <Form.Control {...inputProps} />}
                </InputMask>

                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("otherNumber", this.props.errors)
                  )}
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            {/* <Col xs={12} sm={8}>
              <Form.Group controlId="">
                <Form.Label>
                  Broker License No.<span style={{ color: "#FFFFFF" }}>*</span>
                </Form.Label>
                <Form.Control
                  maxLength="50"
                  defaultValue={this.state.brokerLicenseNo}
                  onChange={this.onChange.bind(this)}
                  name="brokerLicenseNo"
                  type="text"
                  size="lg"
                  onBlur={this.props.handleValidation("brokerLicenseNo")}
                />
                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("brokerLicenseNo", this.props.errors)
                  )}
                </Form.Text>
              </Form.Group>
            </Col> */}
            {/* <Col xs={12} sm={4}>
              <Form.Group controlId="">
                <Form.Label>
                  License Expiration Date<span style={{ color: "#FFFFFF" }}>*</span>
                </Form.Label>
                <InputGroup className="react-date-picker-big blue-wrapper">
                  <DatePicker
                    onChange={(date) => this.setStartDate(date)}
                    value={
                      isNaN(Date.parse(startDate)) ? "" : new Date(startDate)
                    }
                    minDate={new Date(minDate)}
                    name="licenseExpirationDate"
                    format="MM/dd/y"
                    calendarIcon={
                      <span>
                        <DateRange />
                      </span>
                    }
                    clearIcon={null}
                  />
                </InputGroup>
                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("licenseExpirationDate", this.props.errors)
                  )}
                </Form.Text>
              </Form.Group>
            </Col> */}
          </Row>
          <Row>
            {/* <Col xs={12} sm={8}>
              <Form.Group controlId="">
                <Form.Label>Agent License No.</Form.Label>
                <Form.Control
                  maxLength="50"
                  defaultValue={this.state.agentLicenseNo}
                  onChange={this.onChange.bind(this)}
                  name="agentLicenseNo"
                  type="text"
                  size="lg"
                />
              </Form.Group>
            </Col>
            <Col xs={12} sm={4}>
              <Form.Group controlId="">
                <Form.Label>Agent License Expiration Date</Form.Label>
                <InputGroup className="react-date-picker-big blue-wrapper">
                  <DatePicker
                    onChange={(date) => this.setAgentDate(date)}
                    value={
                      isNaN(Date.parse(agentDate)) ? "" : new Date(agentDate)
                    }
                    minDate={new Date(minDate)}
                    name="agentLicenseExpirationDate"
                    format="MM/dd/y"
                    calendarIcon={
                      <span>
                        <DateRange />
                      </span>
                    }
                    clearIcon={null}
                  />
                </InputGroup>
              </Form.Group>
            </Col> */}
          </Row>
          <Row>
            <Col xs={12} sm={8}>
              <Form.Group controlId="">
                <Form.Label>How did you hear about us?</Form.Label>
                <div className="c-select">
                  <select
                    onChange={this.onChange.bind(this)}
                    defaultValue={this.state.knowAboutUs}
                    name="knowAboutUs"
                    className="form-control form-control-lg"
                  >
                    <option value="">Select</option>
                    {this.props.hearAboutUs &&
                      this.props.hearAboutUs.length > 0 &&
                      this.props.hearAboutUs.map((option) => {
                        return (
                          <option value={option.name} key={option._id}>
                            {option.name}
                          </option>
                        );
                      })}
                  </select>
                </div>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Facebook URL</Form.Label>
                <Form.Control
                  maxLength="50"
                  defaultValue={this.state.socialMediaHandles.facebook}
                  onChange={this.onChange.bind(this)}
                  name={"socialMediaHandles.facebook"}
                  type="text"
                  size="lg"
                />
                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("facebook", this.props.errors)
                  )}
                </Form.Text>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Instagram URL</Form.Label>
                <Form.Control
                  maxLength="50"
                  defaultValue={this.state.socialMediaHandles.instagram}
                  onChange={this.onChange.bind(this)}
                  name={"socialMediaHandles.instagram"}
                  type="text"
                  size="lg"
                />
                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("instagram", this.props.errors)
                  )}
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            {/* <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Realtor.com URL</Form.Label>
                <Form.Control
                  maxLength="50"
                  defaultValue={this.state.socialMediaHandles.realtor}
                  onChange={this.onChange.bind(this)}
                  name={"socialMediaHandles.realtor"}
                  type="text"
                  size="lg"
                />
                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("realtor", this.props.errors)
                  )}
                </Form.Text>
              </Form.Group>
            </Col> */}
            {/* <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Zillow URL</Form.Label>
                <Form.Control
                  maxLength="50"
                  defaultValue={this.state.socialMediaHandles.zillow}
                  onChange={this.onChange.bind(this)}
                  name={"socialMediaHandles.zillow"}
                  type="text"
                  size="lg"
                />
                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("zillow", this.props.errors)
                  )}
                </Form.Text>
              </Form.Group>
            </Col> */}
          </Row>
        </Form>
      </div>
    );
  }
}

InvitePersonalInfo.propTypes = {
  errors: PropTypes.object,
  validate: PropTypes.func,
  isValid: PropTypes.func,
  handleValidation: PropTypes.func,
  getValidationMessages: PropTypes.func,
  clearValidations: PropTypes.func,
  getUserData: PropTypes.func,
  updateUserData: PropTypes.func,
};

export default validation(strategy)(InvitePersonalInfo);
